<template>
    <div class="block lg:hidden">
        <div class="dummy-footer"></div>
        <div class="fixed w-full left-0 bottom-0 footer-shadow bg-a-egg-f5ebdc py-3 px-4">
            <div class="text-center text-14 text-a-brown-502314" v-if="isTypeBuy()">
                {{FilterNumberFormat(campaign.pricePerUnit)}} {{ lbl.campaign.baht }}
            </div>
            <div class="flex justify-center items-center" v-else>
                <img class="w-5 mr-2" src="../../../../assets/icon/crown-brown.svg">
                <div class="text-14 text-a-brown-502314">
                    Use {{FilterNumberFormat(campaign.pointPerUnit)}} Crown Points
                </div>
            </div>
            
            <div v-if="isLoginGuest" class="text-12 text-a-red-d14545 text-center mt-3">{{lbl.detail.warnning_guest_1}} <span class="underline cursor-pointer" @click="clickLogin()">{{lbl.detail.warnning_guest_2}}</span></div>
            <div class="mt-3 px-2">
                <RedeemButton
                        class=""
                        :detailController="detailController"
                        :subScriptPackage="subScriptPackage"
                        @clickRedeem="clickRedeem()"
                ></RedeemButton>
            </div>
        </div>
    </div>
</template>
<script>
import RedeemButton from './RedeemButton.vue'
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import { CampaignType } from "@/helper/StaticValue.js";

export default {
    mixins: [AuthStatusMixin,LocaleMixin],
    components: {
        RedeemButton,
    },
    props: {
        detailController: { type: Object, required: true },
        subScriptPackage: { type: Object, default: null }
    },
    data: function () {
        return {
            campaign: null,
        
        };
    },
    created: function () {
        this.campaign = this.detailController.campaign;
    },
    methods: {
        isTypeBuy: function () {
            return this.campaign.type == CampaignType.Buy;
        },
        clickRedeem: function () {
            this.$emit('clickRedeem');
        },
        clickLogin: function () {
            let path = this.$route.path;
            this.$router.push('/login?afterLogin=' + path);
        }
    },
}
</script>
<style lang="scss" scoped>
    .footer-shadow {
        box-shadow: 0 -1px 5px 0 rgba(0, 0, 0, 0.16);
    }
    .dummy-footer {
        height: 98px;
    }
</style>
